import { z } from "zod";

export const OneTimePasswordFormSchema = z.object({
	oneTimePassword: z
		.string()
		.length(6, "Code muss 6 Zeichen lang sein")
		.regex(/^\d{6}$/, "Code muss aus 6 Zahlen bestehen")
		.min(1, "Code ist erforderlich"),
});
